export const createDiscardModalObject = (func, props) =>
  ({ element: 'discardChangesModal', props: { confirmFunc: func, funcProps: props } })

export const deepCopy = object => JSON.parse(JSON.stringify(object))

export const filterObject = object => {
  const filteredObject = {}
  for (const key in object) if (object[key]) filteredObject[key] = object[key]
  return filteredObject
}

export const isEmptyObject = object => Object.entries(object).length === 0
